import { defineComponent as _, computed as i, ref as S, createElementBlock as d, createCommentVNode as T, openBlock as s, createElementVNode as l, createVNode as m, unref as n, withCtx as k, createTextVNode as h, toDisplayString as p, normalizeClass as g, Fragment as j, renderList as z, createBlock as O } from "vue";
import { RevButton as q } from "@ds/components/Button";
import { RevButtonBase as G } from "@ds/components/ButtonBase";
import { RevButtonIcon as y } from "@ds/components/ButtonIcon";
import H from "../../icons/generated/IconChevronDown.vue2.js";
import J from "../../icons/generated/IconChevronLeft.vue2.js";
import K from "../../icons/generated/IconChevronRight.vue2.js";
import { tw as r } from "../../utils/tailwind.js";
import { ELLIPSIS as C } from "./Pagination.constant.js";
import { getPagesToDisplay as M } from "./Pagination.helpers.js";
const Q = ["aria-label"], W = { class: "flex list-none gap-8" }, X = { class: "relative" }, Y = ["aria-hidden"], de = /* @__PURE__ */ _({
  name: "RevPagination",
  __name: "Pagination",
  props: {
    navigationAriaLabel: {},
    previousAriaLabel: {},
    nextAriaLabel: {},
    currentPage: {},
    currentPageLabel: {},
    pageCount: {},
    pageAriaLabel: {},
    pageURL: { type: Function, default: void 0 }
  },
  emits: ["click"],
  setup(w, { emit: x }) {
    const a = w, R = x, f = r`body-1-bold flex h-40 min-w-full items-center justify-center md:min-w-40 md:px-4`, A = [
      f,
      r`text-static-default-mid`
    ], v = [
      f,
      r`focus-visible-outline-default-hi motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`,
      r`group-first:rounded-t-sm group-last:rounded-b-sm md:rounded-sm`
    ], B = [
      v,
      r`bg-action-default-low text-action-default-hi hover:bg-action-default-low-hover`
    ], F = [
      v,
      r`bg-action-default-low-pressed text-onaction-default-low-pressed hover:bg-action-default-low-hoverpressed`
    ], b = i(() => a.currentPage > 1), P = i(() => a.currentPage < a.pageCount), U = i(() => {
      if (a.pageURL && b.value)
        return a.pageURL(a.currentPage - 1);
    }), $ = i(() => {
      if (a.pageURL && P.value)
        return a.pageURL(a.currentPage + 1);
    }), E = i(() => a.pageCount > 1), D = i(() => M(a.currentPage, a.pageCount)), I = (e) => typeof e == "string", o = S(!1);
    function N() {
      o.value = !o.value;
    }
    function c(e) {
      o.value = !1, R("click", { page: e });
    }
    return (e, u) => E.value ? (s(), d("nav", {
      key: 0,
      "aria-label": e.navigationAriaLabel,
      class: "flex justify-center"
    }, [
      l("ul", W, [
        l("li", null, [
          m(n(y), {
            "alternative-text": e.previousAriaLabel,
            class: "mx-4",
            disabled: !b.value,
            icon: n(J),
            to: U.value,
            variant: "secondary",
            onClick: u[0] || (u[0] = (t) => c(e.currentPage - 1))
          }, null, 8, ["alternative-text", "disabled", "icon", "to"])
        ]),
        l("li", X, [
          m(n(q), {
            "aria-controls": "pagination-pages",
            "aria-expanded": o.value,
            "aria-haspopup": "true",
            class: "mt-4 md:hidden",
            icon: n(H),
            size: "small",
            type: "button",
            variant: "secondary",
            onClick: N
          }, {
            default: k(() => [
              h(p(e.currentPageLabel), 1)
            ]),
            _: 1
          }, 8, ["aria-expanded", "icon"]),
          l("ul", {
            id: "pagination-pages",
            class: g(["bg-overlap-default-low shadow-long rounded-sm absolute mt-4 w-full list-none md:relative md:mt-0 md:flex md:gap-8 md:bg-transparent md:shadow-none", { hidden: !o.value }])
          }, [
            (s(!0), d(j, null, z(D.value, (t, V) => {
              var L;
              return s(), d("li", {
                key: V,
                "aria-hidden": t === n(C),
                class: "border-static-default-low group border-b first:rounded-t-sm last:rounded-b-sm last:border-none md:border-none"
              }, [
                I(t) ? (s(), d("span", {
                  key: 0,
                  class: g(A)
                }, p(n(C)), 1)) : (s(), O(n(G), {
                  key: 1,
                  "aria-current": t === e.currentPage ? "page" : void 0,
                  "aria-label": e.pageAriaLabel(t),
                  class: g(
                    t === e.currentPage && !o.value ? F : B
                  ),
                  to: (L = e.pageURL) == null ? void 0 : L.call(e, t),
                  type: "button",
                  variant: "primary",
                  onClick: (Z) => c(t)
                }, {
                  default: k(() => [
                    h(p(t), 1)
                  ]),
                  _: 2
                }, 1032, ["aria-current", "aria-label", "class", "to", "onClick"]))
              ], 8, Y);
            }), 128))
          ], 2)
        ]),
        l("li", null, [
          m(n(y), {
            "alternative-text": e.nextAriaLabel,
            class: "mx-4",
            disabled: !P.value,
            icon: n(K),
            to: $.value,
            variant: "secondary",
            onClick: u[1] || (u[1] = (t) => c(e.currentPage + 1))
          }, null, 8, ["alternative-text", "disabled", "icon", "to"])
        ])
      ])
    ], 8, Q)) : T("", !0);
  }
});
export {
  de as default
};
